import React from 'react'
import './Error.css';
const Errorpage = () => {
  return (
    <div className='errorContent'>
      <picture className='errorGif'>
        <source srcset="/images/404.avifs" type="image/avif"/>
        <img src="/images/404.gif"/>
      </picture>
    </div>
  )
}

export default Errorpage
